<section class="datetime">
  <div class="property-flow-steps" *ngIf="isPropertyFlow">
    <div class="step active">1</div>
    <div class="line"></div>
    <div class="step">2</div>
    <span>Selecciona fecha y hora</span>
  </div>

  <div class="conteiner-calendar-and-hours property-flow">
    <section class="calendar">
      <ngx-daterangepicker-material
        (choosedDate)="changeDate($event)"
        [autoApply]="true"
        [singleDatePicker]="true"
        [locale]="locale"
        [minDate]="today"
        class="ggi-calendar client-section"
        [maxDate]="maxDate"
      >
      </ngx-daterangepicker-material>
    </section>

    <section class="schedules">
      <ng-container *ngIf="schedules.length; else noSchedules">
        <p class="subtitule-2 property-flow">
          {{ dateSelected }}
          <span>Horarios disponibles</span>
        </p>

        <section class="hours">
          <ng-container *ngFor="let item of schedules">
            <button
              class="chip"
              [ngClass]="{ active: item.value === scheduleSelected }"
              type="button"
              [disabled]="item.isDisabled"
              (click)="selectSchedule(item.value)"
            >
              {{ item.value }}
            </button>
          </ng-container>
        </section>
      </ng-container>

      <ng-template #noSchedules>
        <h4>No hay horarios disponibles</h4>
      </ng-template>
    </section>
  </div>

  <div *ngIf="isPropertyFlow">
    <h4 class="question-title">{{ questionI?.question }}</h4>

    <div class="radios-content">
      <label
        class="ggi-radio"
        [ngClass]="{ open: answerOption.isOpen }"
        *ngFor="let answerOption of questionI?.answers"
      >
        <input
          type="radio"
          [(ngModel)]="answer"
          class="checkbox-question"
          value="{{ answerOption.text }}"
          id="{{ answerOption._id }}"
          (change)="validateForm()"
        />
        <span
          class="checkmark"
          [ngClass]="{ open: answerOption.isOpen }"
        ></span>
        <label
          class="body-2"
          for="{{ answerOption._id }}"
          *ngIf="!answerOption.isOpen"
        >
          {{ answerOption.text }}
        </label>
        <div class="ggi-input open-answer" *ngIf="answerOption.isOpen">
          <input
            type="input"
            (focus)="focusOpen()"
            placeholder="{{ answerOption.text }}"
            [(ngModel)]="openAnswer"
            (keyup)="validateForm()"
          />
        </div>
      </label>
    </div>
  </div>
</section>
